<template>
  <div id="co-authorship-decline-dialog"
       class="flex-center">
    <ipub-model width="600px"
                class="copyright-documents"
                :visable="isVisable"
                @confirm="confirm"
                @cancel="cancel"
                :showHeader="false"
                :showFooter="false">
      <div class="co-authorship-decline-dialog-block ">
        <div class="ipub-h4 mar-b-20 tips flex">
          <ipub-icon style="font-size:30px"
                     class="key-color"
                     type="iconDetails" />
          <font class="mar-l-12">Decline Contributor Verification</font>
        </div>
        <div class="ipub-p2 mar-b-20">
          Thank you for taking the time to notify <font class="ipub-p1">{{article.journal.fullName}}</font> that you are not a Contributing Author on "<font class="ipub-p1">{{article.title}}</font>" submitted by <font class="ipub-p1">{{article.firstName}} {{article.lastName}}</font>
        </div>
        <ipub-button type="primary"
                     @click="confirm">Confirm</ipub-button>
        <ipub-button type="primary"
                     plain
                     @click="cancel">Cancel</ipub-button>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import publisher from '@/api/publisher'
import file from '@/api/file'
import mauthor from '@/api/mauthor'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      publisher: {},
      article: {
        journal: {}
      },
      id: '',
      domain: ''
    }
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.id = ''
      } else {
        this.getPublisherInfo('' || 'imr')
        this.getArticle()
        this.getDomain()
      }
    }
  },
  mounted () {
  },
  methods: {
    async getPublisherInfo (id) {
      this.publisher = await publisher.query(id)
    },
    async getArticle () {
      try {
        this.id = this.inputData.coAuthor.code
        this.article = await mauthor.manuscript(this.id)
      } catch (e) {
        this.$router.push('/other-author/notice/' + this.id)
      }
    },
    async getDomain () {
      this.domain = await file.domain()
    },
    async decision (id) {
      try {
        await mauthor.decision(id, {
          status: 'DECLINED'
        })
        this.$message.success({
          title: 'Success',
          content: 'Thank you for your submit!'
        })
      } catch (e) {
        this.$router.push('/other-author/notice/' + id)
      }
    },
    confirm () {
      this.decision(this.id)
      this.$emit('declineSubmit')
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}

</script>

<style lang="scss" scoped>
#co-authorship-decline-dialog {
  .co-authorship-decline-dialog-block {
    padding: 25px 20px;
    box-sizing: border-box;
    .tips {
      border: 2px solid $key_color;
      border-radius: 4px;
      background: $key_color_bg;
      line-height: 50px;
      color: $font_color;
      padding: 0 22px;
    }
  }
}
</style>
